import { PermissionMapping } from '@@/lib/permissions';

export type QicPermission = 'reader' | 'writer';

export const qicPermissionMapping: PermissionMapping<QicPermission>[] = [
  // Prompts section
  {
    permissionSetMapping: {
      writer: ['qic-admin'],
      reader: ['qic-reader', 'qic-admin']
    },
    urlSignature: '/prompts',
    showInNavbar: true,
    label: 'Prompts'
  },
  {
    permissionSetMapping: {
      writer: ['qic-admin']
    },
    urlSignature: '/prompts/create',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/prompts/*',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/promptversions/*',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/prompts/*/*',
    showInNavbar: false
  },

  // Agents section
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/agents',
    showInNavbar: true,
    label: 'AI Agents'
  },
  {
    permissionSetMapping: {
      writer: ['qic-admin']
    },
    urlSignature: '/agents/create',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/agents/*',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/agents/*/versions',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/agents/test/*',
    showInNavbar: false
  },

  // Knowledge Bases section
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/knowledge-bases',
    showInNavbar: true,
    label: 'Knowledge Bases'
  },
  {
    permissionSetMapping: {
      writer: ['qic-admin']
    },
    urlSignature: '/knowledge-bases/create',
    showInNavbar: false
  },
  {
    permissionSetMapping: {
      reader: ['qic-reader', 'qic-admin'],
      writer: ['qic-admin']
    },
    urlSignature: '/knowledge-bases/*',
    showInNavbar: false
  }
];

export default qicPermissionMapping;
